// extracted by mini-css-extract-plugin
export default {"semicircle":"Semicircle_semicircle__DKiiA","semicircleBottom":"Semicircle_semicircleBottom__f1gFB"};